import { render, staticRenderFns } from "./TwentyTwenty.vue?vue&type=template&id=4aa5300e&"
import script from "./TwentyTwenty.vue?vue&type=script&lang=js&"
export * from "./TwentyTwenty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa5300e')) {
      api.createRecord('4aa5300e', component.options)
    } else {
      api.reload('4aa5300e', component.options)
    }
    module.hot.accept("./TwentyTwenty.vue?vue&type=template&id=4aa5300e&", function () {
      api.rerender('4aa5300e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/twenty-twenty/TwentyTwenty.vue"
export default component.exports